export default __webpack_public_path__ + "static/media/grafema_pilates_13.c947b60b.jpg";